module.exports = __webpack_public_path__ + "img/Avatar-88.5210f8b0.svg";